export default {
    routerName: '历史文章详细',
    article: {
        title: '标题',
        description: '描述',
        body: '详细',
        author: '作者',
        status: '状态',
        status0: '草稿',
        status1: '審査拒绝',
        status2: '審査中',
        status9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        disabled: '禁用',
        yes: '是',
        no: '否',
        hits: '浏览量',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
        releaseTime: '公开时间',
    },
};
